
import React, {useState} from 'react';
import type {IfaqApiResponse, Ibanner, Ifaq, IhomeContent} from '../../types'
import { faqClickedEvent } from '../../shared/events/additional.event';
import { useLocation } from 'react-router-dom';

interface IFAQ_Props {
  faqs: Ifaq[];
  limit?: number;
  section?: string;
}
export const FAQ: React.FC<IFAQ_Props> = ({ faqs, limit,section }) => {
  const [expandedFaqId, setExpandedFaqId] = useState<number | null>(null);
  const location = useLocation();

  const handleFaqClick = (faqId: number) => {
    faqClickedEvent(
      section || "Home FAQ",
      location.pathname
    );
    setExpandedFaqId(expandedFaqId === faqId ? null : faqId);
  };
  const displayedFaqs = limit ? faqs.slice(0, limit) : faqs;
  return (
    <div className="faq-items">
      {displayedFaqs.map((faq: any) => (
        <div key={faq.faq_id} className={`faq-item ${expandedFaqId === faq.faq_id ? 'highlighted' : ''}`}>
          <div
            className="faq-question"
            onClick={() => handleFaqClick(faq.faq_id)}
          >
            <span>{faq?.question}</span>
            <button className="faq-toggle-button">
              {expandedFaqId === faq.faq_id ? "-" : "+"}
            </button>
          </div>
          {expandedFaqId === faq.faq_id && (
            <div className="faq-answer">
              {faq.answer ? (
                <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
              ) : (
                <p>{faq.answer}</p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}